import './Footer.scss';
import { PRIVACY_POLICY_URL } from 'constants/privacyPolicyLink';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const Footer: FC = () => {
  const { t } = useTranslation();
  return (
    <footer className="Footer">
      <a
        className="Footer__Link"
        href={PRIVACY_POLICY_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('common.privacyPolicy')}
      </a>
    </footer>
  );
};

export default Footer;
